import React from "react";
import DashboardKpiStatus from "components/DashboardKpiStatus";
import { useState } from "react";
import { Card, CardContent, Grid, Typography, Avatar, Box, } from "@mui/material";
import { CiCalendar } from "react-icons/ci";
import { engineeringKpiMapper } from "./engineeringKpiMapper";
import { useParams } from "react-router-dom";
import { useGetDesignKpisQuery } from "store/slices/apis/designEngineeringDashboardSlice";
import EngListPopup from "./EngineeringListPopup";

const EngineeringKpi = () => {

    const { projectId } = useParams();
    const [rowData, setRowData] = useState(null);
    const { data, isLoading, error } = useGetDesignKpisQuery(projectId);
    const [labelData, setLabelData] = useState()

    const [selectedCategory, setSelectedCategory] = useState(null);
    const [isViewTracker, setIsViewTracker] = useState(false);

    const statusMap = {
        "Total Drawings Planned": "submitted",
        // "Total Drawing Approved": "approved",
        // "Drawing Under Review": "underreview",
        // "Drawing Delayed": "delayed",
        "Drawings Received": "received",
        "Drawings Balance": "balance",
    };





    const handleClick = (point) => {
        const Status = statusMap[point]
        setLabelData(point)
        setIsViewTracker((prev) => {
            const newState = !prev;
            console.log("eng", point)
            setRowData(newState ? { type: Status } : null);
            return newState;
        });
    }

    const handleClose = () => {
        setIsViewTracker(false)
        setRowData(null)
    }

    if (isLoading) {
        return <Box sx={{
            background: "#fff",
            borderRadius: "3px",
            p: 4,
            boxShadow: "0px 4px 20px rgba(0,0,0,0.05)",
            border: "1px solid #E4E4E4",
            textAlign: "center"
        }}>
            <div>Loading KPIs...</div>
        </Box>;
    }


    if (error) {

        console.error("Failed to fetch KPI metrics:", error);
        return (
            <Box sx={{
                background: "#fff",
                borderRadius: "3px",
                p: 4,
                boxShadow: "0px 4px 20px rgba(0,0,0,0.05)",
                border: "1px solid #E4E4E4",
                textAlign: "center"
            }}>
                <div style={{ color: 'red' }}>
                    Error loading data: {error.status} - {error.data?.message || "Please try again."}
                </div>
            </Box>

        );
    }

    const kpis = engineeringKpiMapper(data.data)


    return (
        <>
            <Card
                elevation={0}
                sx={{
                    borderRadius: "3px",
                    border: "1px solid #eef0f4",
                    p: "20px 17px 20px 34px",
                    maxHeight: { xs: "auto", md: "316px" }
                }}
            >
                <Typography sx={{
                    fontFamily: "Poppins, sans-serif",
                    fontWeight: 600,
                    fontSize: '20px',
                    lineHeight: '32px',
                    letterSpacing: "0px",
                    color: "#05004E",

                }}>
                    Drawing Readiness
                </Typography>
                <Typography sx={{
                    fontFamily: "Poppins, sans-serif",
                    fontWeight: 400,
                    fontSize: '16px',
                    lineHeight: '30px',
                    letterSpacing: "0px",
                    color: "#737791",
                    mb: 2
                }}>
                    Compare planned, received, and outstanding drawing commitments.
                </Typography>

                <Grid container spacing={1}>
                    {kpis.map((item) => (
                        <Grid size={{ md: 4 }} key={item.label}>
                            <Card
                                elevation={0}
                                onClick={() => handleClick(item.label)}
                                sx={{
                                    height: "128px",
                                    position: "relative",
                                    borderRadius: "3px",
                                    backgroundColor: "#FFFFFF",
                                    border: "1px solid #E2E8F0",
                                    borderBottom: `3px solid ${item.iconBg}`,
                                    cursor: "pointer"
                                }}
                            >
                                <CardContent
                                    sx={{
                                        gap: 1,
                                        p: 1.25,
                                    }}
                                >
                                    <Avatar
                                        sx={{
                                            width: 30,
                                            height: 30,
                                            backgroundColor: item.iconBg,
                                            fontSize: 18,
                                            fontWeight: 700,
                                        }}
                                    >
                                        <CiCalendar size={16} color="#FFFFFF" />
                                    </Avatar>
                                    <DashboardKpiStatus color={item.iconBg} />

                                    <Typography
                                        sx={{
                                            fontFamily: "Poppins, sans-serif",
                                            fontWeight: 600,
                                            fontSize: "16px",
                                            lineHeight: '21px',
                                            letterSpacing: "0px",
                                            color: '#151D48',
                                            mt: 1
                                        }}
                                    >
                                        {item.value}
                                    </Typography>

                                    <Typography
                                        sx={{
                                            fontFamily: "Poppins, sans-serif",
                                            fontWeight: 500,
                                            fontSize: "12px",
                                            lineHeight: '16px',
                                            letterSpacing: "0px",
                                            color: '#425166',
                                            display: '-webkit-box',
                                            WebkitLineClamp: 2,
                                            WebkitBoxOrient: 'vertical',
                                            overflow: 'hidden'
                                        }}
                                    >
                                        {item.label}
                                    </Typography>
                                </CardContent>
                            </Card>
                        </Grid>
                    ))}
                </Grid>
            </Card>
            {isViewTracker && (
                <EngListPopup
                    header = {labelData}
                    open={isViewTracker}
                    handleClose={handleClose}
                    data={rowData}
                    label="kpi"
                />
            )}
        </>
    );
};

export default EngineeringKpi;
